// ----------------------------------------------------------------------

export const baseVars: Record<string, string | number> = {
  // nav
  '--layout-nav-bg': 'hsl(var(--background))',
  '--layout-nav-border-color': 'hsl(var(--border) / 0.4)',
  '--layout-nav-zIndex': 1101,
  '--layout-nav-mobile-width': '320px',
  // nav item
  '--layout-nav-item-height': '48px',
  '--layout-nav-item-color': 'hsl(var(--muted-foreground))',
  '--layout-nav-item-active-color': 'hsl(var(--foreground))',
  '--layout-nav-item-active-bg': 'hsl(var(--muted))',
  '--layout-nav-item-hover-bg': 'hsl(var(--muted) / 0.6)',
  // header
  '--layout-header-blur': '12px',
  '--layout-header-zIndex': 1100,
  '--layout-header-mobile-height': '64px',
  '--layout-header-desktop-height': '72px',
};
